<template>
  <li @dblclick.stop="$parent.goDetail(item)" class="image-folder--box">
    <img src="@/assets/image/folder.png" class="folder-img" />
    <p class="folder-name text-hidden">{{ item.name }}</p>
    <p class="folder-len">{{ item.files }}个内容</p>
    <span
      class="iconfont icon-More font-icon-more more-act"
      @click.stop="$parent.moreShow(item)"
      @dblclick.stop=""
      v-if="loginInfo.current_team_role !== 4"
    ></span>
    <div
      class="more-box"
      v-if="
        $parent.moreInfo &&
        $parent.moreInfo.id === item.id &&
        $parent.moreStatus
      "
    >
      <p v-if="$route.name == 'Material' || $route.name == 'Template'" @click.stop="copyURL(item.id)">复制链接</p>
      <p @click.stop="$parent.renameClick">重命名</p>
      <p @click.stop="$parent.removeDialogOpen">删除</p>
    </div>
  </li>
</template>

<script>
export default {
  props: ["item", "moreInfo"],
  computed: {
    loginInfo() {
      return this.$store.getters.loginInfo;
    },
  },
  methods: {
    copyURL(id) {
      let val = window.location.origin + window.location.pathname + '?folder=' + window.location.pathname + '_' + id + '_' + this.loginInfo.current_team_domain.split('.')[0];
      var oInput = document.createElement("input");
      oInput.value = val;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象
      document.execCommand("Copy"); // 执行浏览器复制命令
      document.body.removeChild(oInput);
      this.$message.success('复制成功');
      this.$parent.moreStatus = false;
    },
  }
};
</script>

<style lang="scss" scoped>
li {
  width: 150px;
  height: 150px;
  margin: 0 20px 30px 0;
  &:hover {
    background: $hoverColor;
    .more-act {
      display: block;
    }
  }
  img {
    width: 82px;
    height: 70px;
    display: block;
    margin: 18px auto 10px;
  }
  p {
    &.folder-name {
      font-size: 14px;
      color: #3c3c43;
      line-height: 20px;
      height: 20px;
      overflow: hidden;
      text-align: center;
    }
    &.folder-len {
      font-size: 12px;
      color: #646469;
      line-height: 16px;
      height: 16px;
      margin-top: 6px;
      text-align: center;
    }
  }
}
</style>
